export const getImageUrl = (name: string, ext: string) => {
    return `https://spolkanastart.pl/assets/images/upload/${name}.${ext}`
}